import { AirVent } from "lucide-react";
import { Footer, ServiceCard } from "../components";
import OilIcon from "../assets/icons/oil-can.svg?react";
import SprayGunIcon from "../assets/icons/spray-gun.svg?react";
import ItpIcon from "../assets/icons/itp-icon.svg?react";
import ComplexRepairIcon from "../assets/icons/complex-repair.svg?react";
import TireChangeIcon from "../assets/icons/tire-change.svg?react";
import { Helmet } from "react-helmet-async";

const Services = () => {
  return (
    <>
      <Helmet>
        <title>
          Servicii Auto GabyLen: Mecanica, ITP, Tinichigerie & Vopsitorie,
          Schimb Pneuri & Mai Multe | Florești, Cluj
        </title>
        <meta
          name="description"
          content="Găsește toate serviciile auto de care ai nevoie la GabyLen Autoservice din Florești Cluj: ITP, mecanica auto, Tinichigerie &
                    Vopsitorie, schimb de pneuri, aer condiționat și multe altele. Contactează-ne pentru detalii."
        />
        <meta
          name="keywords"
          content="servicii auto Florești, reparații auto Florești Cluj, schimb pneuri Florești, ITP Florești, reparații mecanice Cluj, aer condiționat Florești, geometrie roți Florești Cluj, GabyLen Autoservice Florești"
        />
      </Helmet>
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Serviciile noastre
            </h1>
            <p className="text-gray-600">
              GabyLen Auto Service oferă o gamă largă de servicii pentru a vă
              menține vehiculul în stare optimă. Serviciile noastre includ
              reparații caroserie, vopsitorie, mecanică și ITP. Ne mândrim să
              oferim servicii de înaltă calitate și satisfacție clienților.
              Contactați-ne astăzi pentru a programa o întâlnire.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <ServiceCard
              renderedIcon={
                <SprayGunIcon className={"text-red-600 w-6 h-6"} />
              }
              title="Reparații caroserie"
              description="Echipa noastră de vopsitori și tinichigii este dedicată furnizării de servicii și reparații de top pentru vehiculul dumneavoastră. Folosim cea mai recentă tehnologie și cele mai bune materiale pentru a ne asigura că vehiculul dumneavoastră arată ca nou. De asemenea, aducem un plus farurilor dumneavoastră prin sistemul de recondiționare a farurilor cu polimerizare."
            />
            <ServiceCard
              renderedIcon={<OilIcon className={"fill-red-600 w-6 h-6"} />}
              title="Revizii periodice"
              description="Schimburile periodice sunt esențiale pentru a vă menține vehiculul funcțional, fără probleme ulterioare, și pentru a preveni reparațiile costisitoare. La GabyLen Auto Service, oferim servicii complete de verificare și întreținere a mașinii pentru a vă păstra vehiculul în stare optimă."
            />
            <ServiceCard
              renderedIcon={
                <ComplexRepairIcon className={"fill-red-600 w-6 h-6"} />
              }
              title="Reparații complexe"
              description="În atelierul nostru auto, colegii abordează reparațiile mecanice complexe cu precizie. Cu echipamente de ultimă generație și cunoștințe specializate, redăm mașinii dumneavoastră funcționalitatea optimă."
            />
            <ServiceCard
              renderedIcon={
                <TireChangeIcon className={"fill-red-600 w-7 h-7"} />
              }
              title="Vulcanizare"
              description="Oferim o gamă largă de servicii pentru anvelope, inclusiv schimbarea și echilibrarea lor. Echipa noastră se va asigura că acestea sunt în stare optimă, oferindu-vă o călătorie lină și sigură."
            />
            <ServiceCard
              renderedIcon={<ItpIcon className={"fill-red-600 w-6 h-6"} />}
              title="ITP"
              description="Garantează-ți siguranța pe șosele! Efectuează inspecția tehnică periodică (ITP) la service-ul nostru, un pas obligatoriu la fiecare doi ani conform normelor din România. Rezervă acum ITP-ul la service-ul nostru – rapid și ușor!"
            />
            <ServiceCard
              Icon={AirVent}
              title="Service climă"
              description="Faceți călătoriile de vară să fie o plăcere! Ne asigurăm că temperatura din autovehicul va fi mereu optimă prin verificarea și reparația sistemelor de aer condiționat. Oferim servicii de încărcare cu freon și verificare a etanșeității sistemului. Aveți un miros neplăcut în mașină? Vă oferim igienizarea și ozonizarea sistemului de aer condiționat."
            />
          </div>
        </div>
        <Footer showBorder />
      </div>
    </>
  );
};

export default Services;
